import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import BrowsePage from './pages/BrowsePage';
import EmailDetail from './pages/EmailDetail';

function App() {
  // Teams SDK initialization is handled in AuthProvider
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<BrowsePage />} />
        <Route path="email/:id" element={<EmailDetail />} />
      </Route>
    </Routes>
  );
}

export default App;
